// removed by extract-text-webpack-plugin
module.exports = {"overlay":"ErrorOverlay__overlay___2dgPj","divider":"ErrorOverlay__divider___2p11w","subheading":"ErrorOverlay__subheading___1uhMH","close":"ErrorOverlay__close___e2cZ9","cancel":"ErrorOverlay__cancel___3BAK0"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/projects/matches/components/pitchItForm/ErrorOverlay.scss
// module id = 1839
// module chunks = 0